import { Component, ElementRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSnackBar, MatSnackBarModule, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Subscription, firstValueFrom, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { NotificationPushComponent } from '../notification-push/notification-push.component';
import { ETNotification } from '@src/app/models/ETnotification';
import { NotificationService } from './service/notification.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { Auth } from 'aws-amplify';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { NotificationStateService } from '@src/app/helpers/notification-state.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
  animations: [
    trigger(
      'inbgOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ opacity: 0 }),
            animate('0.2s ease-out',
              style({ opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ opacity: 1 }),
            animate('0.2s ease-in',
              style({ opacity: 0 }))
          ]
        )
      ]
    )
  ]
})

export class NotificationComponent implements OnInit {
  @Input() customerportal: boolean;
  subscription: Subscription;
  statusText: string;
  notificationList: ETNotification[];
  allNotificationList: ETNotification[];
  notificationInclReadList: ETNotification[];
  newNotificationList: ETNotification[];
  showNotifications: boolean;
  showConfirmation: boolean;
  showAllNotifications: boolean;
  @Output() webpush: ETNotification;
  @Output() showSpinner: boolean;


  constructor(
    private notsrv: NotificationService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private uievent: UieventhubService,
    private authservice: AuthorizationService,
    private datastorage: DatastoreService,
    private notificationState: NotificationStateService) { }

  private syncNotificationState(result: ETNotification[]) {
    const snapshot = this.notificationState.buildState(result);
    this.allNotificationList = snapshot.all;
    this.newNotificationList = snapshot.unread;
    this.uievent.setNotification(snapshot.latest);
  }

  canEditOrg() {
    return this.authservice.isAuthorized('org_edit', SessionHelper.getChoosenOrg());
  }
  timeregEnabled() {
    return SessionHelper.hasModule('timereg');
  }
  unfolddd() {
    this.uievent.setCloseChat('close');
  }
  ngOnInit() {

    this.showSpinner = false;
    this.notificationList = [];
    this.showConfirmation = false;
    var oneYearAgo = new Date();
    oneYearAgo.setMonth(oneYearAgo.getMonth() - 1);
    this.datastorage.load();
    timer(0, 5000).subscribe(() => {
      this.datastorage.load();
    }

    );


    //this.notsrv.getNotifications(oneYearAgo))).pipe(untilDestroyed(this)).subscribe(result => {
    this.datastorage.notifications$.pipe(untilDestroyed(this)).subscribe(result => {
      this.syncNotificationState(result);
      const previousUnreadCount = parseInt(sessionStorage.getItem('numberOfNotifications') || '0', 10);
      const currentUnreadCount = this.newNotificationList.length;

      if (result.length > 0) {
        //console.log('newNotificationList',this.newNotificationList);
        //console.log('numberOfNotifications',sessionStorage.getItem('numberOfNotifications'));
        //On initial load set numberOfNotifications in session 
        if (!sessionStorage.getItem('numberOfNotifications')) {
          this.notificationState.setSessionUnreadCount(result);
        } else if (previousUnreadCount !== currentUnreadCount) {
          this.notificationState.setSessionUnreadCount(result);
          if (currentUnreadCount > previousUnreadCount && this.newNotificationList[0]) {
            const audio = new Audio('/assets/assets/sound.mp3');

            audio.play().then(_ => {
              // Autoplay started!
            }).catch(error => {
              console.debug('error', error);
              // Autoplay was prevented.
              // Show a "Play" button so that user can start playback.
            });
            this.openSnackBar(JSON.stringify(this.newNotificationList[0]));
          }

        } else {
          //this.webpush = undefined;
          // this.fillUpNotificationList()
        }
      } else {
        this.notificationState.setSessionUnreadCount(result);
      }
    });
  }


  // fillUpNotificationList(){
  //   if(this.allNotificationList.length > 4){
  //     this.newNotificationList = this.allNotificationList.slice(0,4);
  //   }else{
  //     this.newNotificationList = this.allNotificationList;
  //   }
  // }
  openSnackBar(message: string) {
    this._snackBar.openFromComponent(NotificationPushComponent, {
      data: message,
      panelClass: ["custom-style"],
      horizontalPosition: 'center',
      verticalPosition: 'bottom',

    });
  }


  navigate(link: string) {
    let path = link.substring(link.indexOf(link.split('/')[2]));
    //console.log('path',path);
    this.router.navigate(['/' + path]);
    //this.router.navigateByUrl(link.substr(link.indexOf(link.split('/')[3])));
  }
  markRead(notif: ETNotification) {
    this.showSpinner = true;
    const currentNotifications = this.datastorage.notifications.getValue() || [];
    const nextNotifications = this.notificationState.applyRead(currentNotifications, notif, SessionHelper.getChoosenOrg());
    this.datastorage.notifications.next(nextNotifications);
    this.notificationState.setSessionUnreadCount(nextNotifications);

    this.notsrv.markRead({ ...notif, organization: SessionHelper.getChoosenOrg(), dateread: new Date().toISOString() }).pipe(untilDestroyed(this)).subscribe(result => {
      const syncedNotifications = this.notificationState.mergeNotification(this.datastorage.notifications.getValue() || [], result);
      this.datastorage.notifications.next(syncedNotifications);
      this.notificationState.setSessionUnreadCount(syncedNotifications);
      this.showSpinner = false;
    }, _error => {
      this.datastorage.notifications.next(currentNotifications);
      this.notificationState.setSessionUnreadCount(currentNotifications);
      this.showSpinner = false;
    });
  }
  markUnRead(notif: ETNotification) {
    const currentNotifications = this.datastorage.notifications.getValue() || [];
    const nextNotifications = this.notificationState.applyUnread(currentNotifications, notif, SessionHelper.getChoosenOrg());
    this.datastorage.notifications.next(nextNotifications);
    this.notificationState.setSessionUnreadCount(nextNotifications);

    this.notsrv.markUnRead({ ...notif, organization: SessionHelper.getChoosenOrg(), dateread: this.notificationState.unreadSentinel }).pipe(untilDestroyed(this)).subscribe(result => {
      const syncedNotifications = this.notificationState.mergeNotification(this.datastorage.notifications.getValue() || [], result);
      this.datastorage.notifications.next(syncedNotifications);
      this.notificationState.setSessionUnreadCount(syncedNotifications);
    }, _error => {
      this.datastorage.notifications.next(currentNotifications);
      this.notificationState.setSessionUnreadCount(currentNotifications);
    });
  }
  openChat() {
    this.uievent.setshowchatcollapse(true);
    SessionHelper.setChatShow("chat");
  }
  showOldNotifications() {
    this.showAllNotifications = true;

    var oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    this.notsrv.getNotifications(oneYearAgo).pipe(untilDestroyed(this)).subscribe(result => {
      this.notificationInclReadList = result;
      this.notificationInclReadList.sort((a, b) => new Date(b.datecreated).getTime() - new Date(a.datecreated).getTime());

    });
  }
  openNotifications() {
    SessionHelper.setChatShow("notification");
    this.uievent.setShowNotification('show');
    this.uievent.setshowchatcollapse(true);
  }
  closeAllNotification() {
    this.showAllNotifications = false;
  }
  toggleList() {
    this.uievent.setShowNotification('show');
  }
  onLogoutClickedConfirmation() {
    this.showConfirmation = true;
  }
  onLogoutClickedStay() {
    this.showConfirmation = false;
  }
  async onLogoutClicked() {
    this.uievent.setshowchatcollapse(false);
    this.datastorage.clearData();
    SessionHelper.clear();
    try {
      await firstValueFrom(this.notsrv.logout());
    } catch (_error) {
      console.error('Logout failed', _error);
    }
    this.router.navigate(['/login']);
  }

  isread(notf: ETNotification) {
    return notf.dateread <= new Date().toISOString();
  }
}
